import { Component } from "@angular/core";
import { BaseComponent, IDatatableStateSaveableComponent } from "@impacgroup/angular-baselib";

@Component({
    selector: "app-orderitems-main",
    templateUrl: "./orderitems.main.component.html",
    standalone: false
})
export class OrderItemsMainComponent extends BaseComponent implements IDatatableStateSaveableComponent {
    public listStateData: any;
}
